<script async setup>
import { defineProps, onMounted, ref, defineExpose } from "vue";
import { tns } from "tiny-slider";

const props = defineProps({
    elementId: {
        type: [Number, String],
        required: true
    },
    categories: {
        type: Array,
        default: () => []
    },
});

const rootEl = ref(null);
const sliderApi = ref(null);
const activeIndex = ref(0);

onMounted(() => {
  sliderApi.value = tns({
    container: `#slider-${props.elementId}`,
    items: 1,
    slideBy: 1,
    gutter: 20,
    controls: false,
    nav: false,
    mouseDrag: false,
    touch: false,
    speed: 400,
    loop: false,
    rewind: true,
    center: false,
  });

  const updateActive = () => {
    const info = sliderApi.value?.getInfo?.();
    activeIndex.value = info?.index ?? 0;
  };

  sliderApi.value?.events?.on("indexChanged", updateActive);
  updateActive();
});

const goTo = (index) => {
  if (!sliderApi.value) return;
  sliderApi.value.goTo(index);
  activeIndex.value = index;
};

defineExpose({ goTo });
</script>

<template>
    <div class="py-1">
        <div v-if="categories.length" class="mb-4 flex flex-wrap gap-2">
            <kd-button
                v-for="(cat, i) in categories"
                :key="i"
                :variant="activeIndex === i ? 'black' : 'white'"
                :title="cat"
                @click="goTo(i)"
            >
                {{ cat }}
            </kd-button>
        </div>    
        <div class="py-1" :id="'slider-' + props.elementId" ref="rootEl">
            <slot />
        </div>
    </div>
</template>